<template>
  <div class="treasureChest">
    <div class="t-left" v-if="menuList.length">
      <div class="list">
        <div
          class="list-item"
          :class="{ active: item.value === menuValue }"
          v-for="(item, index) in menuList"
          :key="index"
          @click="goToPage(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="t-right" v-if="menuList.length">
      <FAQ v-if="menuValue === '1'" />
      <successCase v-if="menuValue === '2'" />
      <palmInterpretation v-if="menuValue === '3'" />
    </div>
    <div class="t-right" v-else>
      <empty text="暂无权限"></empty>
    </div>
  </div>
</template>

<script>
import FAQ from "./FAQ/index.vue";
import successCase from "./successCase/index.vue";
import palmInterpretation from "./palmInterpretation/index.vue";
import { hasAuth } from "@/utils/uEdition.js";

export default {
  components: {
    FAQ,
    successCase,
    palmInterpretation,
  },
  data() {
    return {
      menuValue: "1",
      menuList: [],
    };
  },
  methods: {
    goToPage(value) {
      this.menuValue = value;
    },
    init() {
      let arr = [];
      if (hasAuth("YZ-22")) {
        arr.push({
          label: "FAQ",
          value: "1",
        });
      }
      if (hasAuth("YZ-10")) {
        arr.push({
          label: "成功病案库",
          value: "2",
        });
      }
      if (hasAuth("YZ-28")) {
        arr.push({
          label: "手相解读",
          value: "3",
        });
      }
      if (arr.length > 0) {
        this.menuValue = arr[0].value;
      } else {
        this.menuValue = "";
      }
      this.menuList = arr;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.treasureChest {
  display: flex;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;

  .t-left {
    width: 200px;
    height: 100%;
    flex-shrink: 0;
    background: #fff;
    margin-right: 15px;
    border-radius: 10px;
    padding: 15px;
    .list-item {
      cursor: pointer;
      line-height: 35px;
      height: 35px;
      text-align: center;
      margin-bottom: 10px;
      border-radius: 5px;
      &.active {
        color: #f50304;
        background: #fff2f1;
      }
    }
  }
  .t-right {
    overflow: hidden;
    width: 100%;
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
  }
}
</style>